"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9063,9307,1275],{

/***/ 49063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71109);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83944);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19599);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8072);
/* harmony import */ var assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94027);
/* harmony import */ var hooks_useCustomMediaQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83910);
/* harmony import */ var hooks_useFindLocation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76035);
/* harmony import */ var redux_search_selectors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46184);
/* harmony import */ var redux_settings_reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66126);
/* harmony import */ var utility_booleanParser__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58256);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79307);












var CustomBackdrop = function() {
    var backdrop = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(redux_settings_reducer__WEBPACK_IMPORTED_MODULE_7__/* .getSettingsLoading */ .dx).backdrop;
    var isDesktop = (0,hooks_useCustomMediaQuery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().isDesktop;
    var isSearchPage = (0,hooks_useFindLocation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().isSearchPage;
    var appliesFilter = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(redux_search_selectors__WEBPACK_IMPORTED_MODULE_9__/* .getAppliesFilter */ .VU);
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query;
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        var higherPX = isSearchPage;
        if (backdrop) {
            window.scrollTo({
                top: higherPX ? isDesktop ? (0,utility_booleanParser__WEBPACK_IMPORTED_MODULE_10__/* .booleanParser */ .P)(query === null || query === void 0 ? void 0 : query.app_keepa) ? 190 : 350 : (0,utility_booleanParser__WEBPACK_IMPORTED_MODULE_10__/* .booleanParser */ .P)(query === null || query === void 0 ? void 0 : query.app_keepa) ? 40 : 85 : 0,
                behavior: "smooth"
            });
        }
    }, [
        backdrop,
        isSearchPage,
        isDesktop,
        appliesFilter,
        query === null || query === void 0 ? void 0 : query.app_keepa
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            display: backdrop ? "flex" : "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            sx: {
                zIndex: function(theme) {
                    return theme.zIndex.drawer + 1;
                }
            },
            open: backdrop,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_8__["default"], {
                src: assets__WEBPACK_IMPORTED_MODULE_4__/* .KeepaWhiteLogoRight */ .EwQ,
                quality: 10,
                priority: true,
                width: 160,
                height: 160
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CustomBackdrop);


/***/ }),

/***/ 79307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81663);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43903);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59416);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43493);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19599);
/* harmony import */ var utility_shimmer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34115);







var ImageKit = function(props) {
    var src = props.src, alt = props.alt, width = props.width, height = props.height, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "src",
        "alt",
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        blurDataURL: "data:image/svg+xml;base64,".concat((0,utility_shimmer__WEBPACK_IMPORTED_MODULE_5__/* .shimmer */ .f)(width, height, 12)),
        src: src || "",
        alt: alt,
        width: width,
        height: height
    }, !others.priority && {
        loading: "lazy"
    }, others));
};
/* harmony default export */ __webpack_exports__["default"] = (ImageKit);
ImageKit.defaultProps = {
    quality: 50,
    layout: "intrinsic",
    priority: false,
    src: "",
    alt: "keepa"
};
ImageKit.propTypes = {
    layout: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOf([
        "fill",
        "intrinsic",
        "responsive",
        "fixed"
    ]),
    priority: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
    src: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    loader: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    blurDataURL: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    objectFit: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};


/***/ }),

/***/ 83910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83811);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96528);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35829);



var useCustomMediaQuery = function() {
    var theme = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(theme.breakpoints.down("md"));
    var isTablet = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(theme.breakpoints.between("sm", "md"));
    var isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(theme.breakpoints.up("md"));
    var isOnlyLg = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(theme.breakpoints.only("lg"));
    var isIOSdevice = react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isIOS */ .gn;
    return {
        isTablet: isTablet,
        isMobile: isMobile,
        isDesktop: isDesktop,
        isOnlyLg: isOnlyLg,
        isIOSdevice: isIOSdevice
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomMediaQuery);


/***/ }),

/***/ 76035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83944);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var useFindLocation = function() {
    var ref, ref1;
    var ref2 = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(), pathname = ref2.pathname, query = ref2.query;
    var isSearchPage = pathname.includes("/search");
    var isStoresPage = pathname.includes("/stores") && !(query === null || query === void 0 ? void 0 : (ref = query.all) === null || ref === void 0 ? void 0 : ref.length);
    var isStoreDetailsPage = pathname.includes("/stores") && !(query === null || query === void 0 ? void 0 : (ref1 = query.all) === null || ref1 === void 0 ? void 0 : ref1.length);
    var isEntekhabinoPage = pathname.includes("/entekhabino");
    var isEntekhabPage = pathname.includes("/entekhab");
    var isDigiKalaPage = pathname.includes("/digikala");
    var isRegistration = pathname.includes("/landing/medu");
    var isFara = pathname.includes("/landing/fara");
    return {
        isSearchPage: isSearchPage,
        isStoresPage: isStoresPage,
        isStoreDetailsPage: isStoreDetailsPage,
        isEntekhabinoPage: isEntekhabinoPage,
        isEntekhabPage: isEntekhabPage,
        isDigiKalaPage: isDigiKalaPage,
        isRegistration: isRegistration,
        isFara: isFara
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFindLocation);


/***/ }),

/***/ 34115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ shimmer; }
/* harmony export */ });
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var shimmer = function(w, h, b) {
    return toBase64('\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#ddd" offset="20%" />\n      <stop stop-color="#eee" offset="50%" />\n      <stop stop-color="#ddd" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#ddd" rx="').concat(b, '" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" rx="').concat(b, '" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>'));
};



/***/ })

}]);